import { createApp, h } from "vue";
import List from "./components/List";
import Item from "./components/Item";
import { plugin, defaultConfig } from "@formkit/vue";

const app = createApp({
    render: () => h(List, { value: window.menu ?? [] }),
});

app.component('Item', Item)

app.use(
    plugin,
    defaultConfig({
        config: {
            classes: {
                input: 'form-control',
                wrapper: 'form-group',
            },
        },
    })
);

app.mount("#menu-items");